<template>
  <div class="dashboard-page k-page padding-50 pos-relative">
    <div class="text-right padding-b-20">
      <KSelect v-model="selectedTechProvider" v-if="isVisible" class="k-select" placeholder="All listings" :optionList="allListings" isClearable="true" :isFilterable="true" style="width:200px;margin-right:10px;text-align:left" @select="handleOnSelect"/>
    </div>
    <Stats :counts="dashboardData" v-if="!selectedTechProvider"/>
    <div class="dashboard-page k-page padding-20 pos-relative">
      <router-view :dashboardData="dashboardData"/>
    </div>
    <Spin size="large" fix v-if="isLoading"></Spin>
  </div>
</template>

<script>
import { fetchMyListings } from '@/services/my-listings'
import { fetchDashboardAnalytics, fetchCompanyDashboard } from '@/services/dashboard'
import Stats from '@/components/analytics/Stats'
import KSelect from '@/components/ui/Select'

export default {
  components: {
    Stats,
    KSelect
  },

  data () {
    return {
      isLoading: false,
      dashboardData: {
        published: 0,
        pending: 0,
        week_visit: 0
      },
      selectedTechProvider: '',
      allListings: [],
      allListingsRaw: [],
      isVisible: true
    }
  },

  watch: {
    '$route.name' (val) {
      if (val === 'dashboard') {
        this.isVisible = true
      } else {
        this.isVisible = false
      }
    }
  },

  mounted () {
    this.getDashboardAnalytics()
    this.getMyListings()
    if (this.$route.name === 'dashboard') {
      this.isVisible = true
    } else {
      this.isVisible = false
    }
  },

  methods: {
    getDashboardAnalytics () {
      this.isLoading = true
      this.dashboardData = Object.assign({}, this.handleResetData())
      fetchDashboardAnalytics().then(res => {
        if (res.data.results.length) {
          this.dashboardData = { ...res.data.results[0] }
        } else {
          this.dashboardData = Object.assign({}, this.handleResetData())
        }
        this.isLoading = false
      }).catch(err => {
        console.log('Failed to fetch dashboard analytics: ', err)
        this.isLoading = false
        this.dashboardData = Object.assign({}, this.handleResetData())
      })
    },

    getMyListings () {
      this.isLoading = true
      fetchMyListings().then(res => {
        if (res.data.results.length > 0) {
          this.allListingsRaw = res.data.results[0].all_listing
          this.allListings = this.parseAllListings(res.data.results[0].all_listing)
        }
        this.isLoading = false
      }).catch(err => {
        console.log('Failed to get my listings: ', err)
        this.isLoading = false
      })
    },

    parseAllListings (data) {
      if (data && data.length > 0) {
        return data.reduce((acc, cur) => {
          acc.push({
            value: cur.id,
            label: cur.name
          })
          return acc
        }, [])
      } else {
        return []
      }
    },

    handleOnSelect (val) {
      this.isLoading = true
      if (val) {
        fetchCompanyDashboard(val).then(res => {
          this.dashboardData = { ...res.data[0] }
          this.isLoading = false
        }).catch(err => {
          console.log('Failed to get company analytics: ', err)
          this.dashboardData = Object.assign({}, this.handleResetData())
          this.isLoading = false
        })
      } else {
        this.getDashboardAnalytics()
      }
    },

    handleResetData () {
      return {
        browsers: [],
        countries: [],
        devices: [],
        pending: 0,
        platforms: [],
        published: 0,
        references: [],
        unique_views: [],
        unique_visits: [],
        views: [],
        visits: [],
        week_visit: 0
      }
    }
  }
}
</script>
